import * as React from "react";
import { Button } from "@progress/kendo-react-buttons";
import Vatlist from "./vatlist";
import styles from "../Settings.module.scss";
import EditVat from "./Editvat";
import { toast } from "react-toastify";
import { addVat } from "../../../services/vatService";

const Vatcodes = (props) => {
  const [isFormOpen, setIsFormOpen] = React.useState(false);

  const handleOpenForm = () => {
    setIsFormOpen(true);
    props.open?.();
  };

  const handleCloseForm = () => {
    setIsFormOpen(false);
  };

  const handleSubmit = async (formData) => {
    try {
      await addVat(formData);
      toast.success("VAT Added");
      handleCloseForm();
    } catch (error) {
      toast.error("Error occurred while adding VAT");
    }
  };

  return (
    <React.Fragment>
      <div className="d-flex flex-column">
        <div className="d-flex ms-auto mt-5 me-5">
          <Button
            className={`common-btn ${styles.button} me-5`}
            onClick={handleOpenForm}
          >
            Add VAT
          </Button>
        </div>

        <div className="settings-grid-wrapper">
          <Vatlist />
        </div>
      </div>

      {isFormOpen && (
        <EditVat
          cancelEdit={handleCloseForm}
          type="addNew"
          onSubmit={handleSubmit}
        />
      )}
    </React.Fragment>
  );
};

export default Vatcodes;
